import LoginContainer from '../components/LoginContainer'
import { connect } from 'react-redux'
import { login, register, temporaryLogin, resetPasssword } from '../reducers/actions'

const mapStateToProps = (state) => ({
    user: state.user
})

const mapDispatchToProps = (dispatch, { socket }) => ({
    onLogin: ({ name, username, password }) => dispatch(login(socket, username, password, name)),
    onRegister: ({ email, username, password }) => dispatch(register(socket, email, username, password)),
    onTemporaryLogin: ({username, password, nameGame }) => dispatch(temporaryLogin(socket, username, password, nameGame)),
    onResetPassword: ({email}) => dispatch(resetPasssword(socket, email))

})

const Login = connect(
    mapStateToProps, 
    mapDispatchToProps
)(LoginContainer)

export default Login



// WEBPACK FOOTER //
// ./src/containers/Login.js